import { render } from "./component-receiver-adress.vue?vue&type=template&id=c3a2d012"
import script from "./component-receiver-adress.vue?vue&type=script&setup=true&lang=js"
export * from "./component-receiver-adress.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/views/contracts/contract-card/components/component-receiver-adress.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "c3a2d012"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('c3a2d012', __exports__)) {
    api.reload('c3a2d012', __exports__)
  }
  
  module.hot.accept("./component-receiver-adress.vue?vue&type=template&id=c3a2d012", () => {
    api.rerender('c3a2d012', render)
  })

}


export default __exports__